export const css = {
    root: '_26-vhLhd',
    studyplan_carousel: '_2YYD7C5F',
    domain_carousels: '_2oAsWZSB',
    ' _key': 'certwise-theme/certwise/explore-view/carousel-view'
};
export default css;
